import React, { Component } from 'react';
import _ from 'lodash';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';

import styles from './styles';
import { DataTable } from 'components';

import PermissionCategories from 'views/PermissionCategories';
import { getAll } from './_actions';

// Inject reducers
import { store } from 'utils/store';
import { permissionCategoriesList } from './_reducers';
store.injectReducer('permissionCategoriesList', permissionCategoriesList);


class PermissionCategoriesList extends Component {

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAll());
  }

  prepareTableColumns() {
    const { t } = this.props;
    const columns = [
      'ID',
      'LINK',
      t('Pavadinimas'),
      t('Priskirta teisių'),
    ];

    return columns;
  }

  prepareTableData(records) {
    const data = _.map(records, record => {
      let row = [];

      row.push(record._id);
      row.push(`/permission-categories/${record._id}`);
      row.push(record.title);
      row.push(record.permissions ? record.permissions.length : null);
      
      return row;
    });

    return data;
  }

  render() {
    const { classes, records, isLoading, t } = this.props;

    const columns = this.prepareTableColumns();
    const data = this.prepareTableData(records);

    return (
      <PermissionCategories
        title={t('Prieigos teisių kategorijos')}
        isLoading={isLoading}
        breadcrumbs={[
          { title: t('Administravimas') },
          { title: t('Prieigos teisių kategorijos') },
        ]}
      >
        
        <div className={classes.content}>
          {!isLoading && (
            <DataTable 
              columns={columns}
              data={data}
              tableHeight={window.innerHeight > 900 ? '65vh' : '45vh'}
              createUrl="/permission-categories/create"
              // onDelete={(idx) => dispatch(deleteOne(companies[idx]._id))}
              // onDeleteBatch={(indexes) => dispatch(deleteBatch(_.map(indexes, (idx) => companies[idx]._id)))}
            />
          )}
        </div>

      </PermissionCategories>
    );
  }
}

const mapStateToProps = ({ permissionCategoriesList, dispatch }) => {
  return { 
    ...permissionCategoriesList,
    dispatch,
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
  withTranslation(),
)(PermissionCategoriesList);